import { useState } from "react";
import { cn } from "@/lib/cn";
import { safeMediaHref } from "@/lib/safe-url";

/** A brand's logo tile (its app icon or site logo), or its initial on white when it has none or the image fails to load. */
export function BrandMark({ name, logoUrl, className, textClassName }: { name: string; logoUrl?: string | null; className: string; textClassName?: string }) {
  const src = safeMediaHref(logoUrl);
  const [failed, setFailed] = useState<string | null>(null);
  if (src && failed !== src) return <img src={src} alt="" className={cn("object-cover", className)} onError={() => setFailed(src)} />;
  return <span className={cn("grid place-items-center bg-white font-bold text-black", className, textClassName)}>{name.charAt(0).toUpperCase()}</span>;
}
